export default __webpack_public_path__ + "static/media/yelloww.10bc2f9e.gif";